export const SMALL = 'small';
export const MEDIUM = 'medium';
export const LARGE = 'large';
export const CUSTOM = 'custom';
